import React from "react";
import { useSelector } from "react-redux";
import {
  selectSuperlativesStatus,
} from "../../superlatives/superlativeSlice";
import {
  SUPERLATIVES_STATUS_FINALE,
} from "../../../provider/firebase/constants";
import BigScreenReveal from "../../superlatives/components/BigScreenReveal";
import FinalePoster from "../../superlatives/components/FinalePoster";

const FinalCredits = () => {
  const status = useSelector(selectSuperlativesStatus);

  if (status === SUPERLATIVES_STATUS_FINALE) {
    return <FinalePoster />;
  }
  // Default to revealing — handles "generating" gracefully (BigScreenReveal returns null until superlatives load)
  return <BigScreenReveal />;
};

export { FinalCredits };
